// @flow
export const GET_SELLER_EMAIL = 'GET_SELLER_EMAIL';

type State = $ReadOnly<{
  email: ?string,
}>;

const initialState: State = { email: null };

export const sellerInfoReducer = (state: State = initialState, action: Action<*>) => {
  switch (action.type) {
    case GET_SELLER_EMAIL: {
      return {
        ...state,
        email: action.payload.sellerInfo ? action.payload.sellerInfo.email : null,
      };
    }
    default:
      return state;
  }
};
